import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "default11": "companies-frontend-b21b3468-default11-WXUgJq",
  "grid": "companies-frontend-b21b3468-grid-WXUgJq",
  "xwide10": "companies-frontend-b21b3468-xwide10-WXUgJq",
  "confinedOffset3": "companies-frontend-b21b3468-confinedOffset3-WXUgJq",
  "xwide12": "companies-frontend-b21b3468-xwide12-WXUgJq",
  "tiny1": "companies-frontend-b21b3468-tiny1-WXUgJq",
  "tiny10": "companies-frontend-b21b3468-tiny10-WXUgJq",
  "tinyOffset5": "companies-frontend-b21b3468-tinyOffset5-WXUgJq",
  "confinedOffset5": "companies-frontend-b21b3468-confinedOffset5-WXUgJq",
  "wide9": "companies-frontend-b21b3468-wide9-WXUgJq",
  "wideOffset11": "companies-frontend-b21b3468-wideOffset11-WXUgJq",
  "default7": "companies-frontend-b21b3468-default7-WXUgJq",
  "tinyOffset11": "companies-frontend-b21b3468-tinyOffset11-WXUgJq",
  "wideOffset0": "companies-frontend-b21b3468-wideOffset0-WXUgJq",
  "default4": "companies-frontend-b21b3468-default4-WXUgJq",
  "wide5": "companies-frontend-b21b3468-wide5-WXUgJq",
  "tiny3": "companies-frontend-b21b3468-tiny3-WXUgJq",
  "defaultOffset10": "companies-frontend-b21b3468-defaultOffset10-WXUgJq",
  "xwide5": "companies-frontend-b21b3468-xwide5-WXUgJq",
  "default0": "companies-frontend-b21b3468-default0-WXUgJq",
  "tiny0": "companies-frontend-b21b3468-tiny0-WXUgJq",
  "xwideOffset2": "companies-frontend-b21b3468-xwideOffset2-WXUgJq",
  "xwideOffset3": "companies-frontend-b21b3468-xwideOffset3-WXUgJq",
  "confined9": "companies-frontend-b21b3468-confined9-WXUgJq",
  "tinyOffset1": "companies-frontend-b21b3468-tinyOffset1-WXUgJq",
  "default5": "companies-frontend-b21b3468-default5-WXUgJq",
  "wideOffset7": "companies-frontend-b21b3468-wideOffset7-WXUgJq",
  "tinyOffset2": "companies-frontend-b21b3468-tinyOffset2-WXUgJq",
  "defaultOffset8": "companies-frontend-b21b3468-defaultOffset8-WXUgJq",
  "tinyOffset6": "companies-frontend-b21b3468-tinyOffset6-WXUgJq",
  "defaultOffset7": "companies-frontend-b21b3468-defaultOffset7-WXUgJq",
  "default8": "companies-frontend-b21b3468-default8-WXUgJq",
  "defaultOffset2": "companies-frontend-b21b3468-defaultOffset2-WXUgJq",
  "xwide8": "companies-frontend-b21b3468-xwide8-WXUgJq",
  "confinedOffset11": "companies-frontend-b21b3468-confinedOffset11-WXUgJq",
  "xwide6": "companies-frontend-b21b3468-xwide6-WXUgJq",
  "xwideOffset0": "companies-frontend-b21b3468-xwideOffset0-WXUgJq",
  "confinedOffset2": "companies-frontend-b21b3468-confinedOffset2-WXUgJq",
  "confined1": "companies-frontend-b21b3468-confined1-WXUgJq",
  "wide3": "companies-frontend-b21b3468-wide3-WXUgJq",
  "wideOffset9": "companies-frontend-b21b3468-wideOffset9-WXUgJq",
  "xwide0": "companies-frontend-b21b3468-xwide0-WXUgJq",
  "tinyOffset3": "companies-frontend-b21b3468-tinyOffset3-WXUgJq",
  "defaultOffset6": "companies-frontend-b21b3468-defaultOffset6-WXUgJq",
  "default6": "companies-frontend-b21b3468-default6-WXUgJq",
  "tiny6": "companies-frontend-b21b3468-tiny6-WXUgJq",
  "confinedOffset6": "companies-frontend-b21b3468-confinedOffset6-WXUgJq",
  "wideOffset10": "companies-frontend-b21b3468-wideOffset10-WXUgJq",
  "xwide3": "companies-frontend-b21b3468-xwide3-WXUgJq",
  "tiny4": "companies-frontend-b21b3468-tiny4-WXUgJq",
  "confined12": "companies-frontend-b21b3468-confined12-WXUgJq",
  "confinedOffset1": "companies-frontend-b21b3468-confinedOffset1-WXUgJq",
  "wide7": "companies-frontend-b21b3468-wide7-WXUgJq",
  "defaultOffset4": "companies-frontend-b21b3468-defaultOffset4-WXUgJq",
  "wide11": "companies-frontend-b21b3468-wide11-WXUgJq",
  "tinyOffset10": "companies-frontend-b21b3468-tinyOffset10-WXUgJq",
  "wide10": "companies-frontend-b21b3468-wide10-WXUgJq",
  "tiny9": "companies-frontend-b21b3468-tiny9-WXUgJq",
  "confinedOffset8": "companies-frontend-b21b3468-confinedOffset8-WXUgJq",
  "tiny2": "companies-frontend-b21b3468-tiny2-WXUgJq",
  "default1": "companies-frontend-b21b3468-default1-WXUgJq",
  "tiny11": "companies-frontend-b21b3468-tiny11-WXUgJq",
  "tinyOffset7": "companies-frontend-b21b3468-tinyOffset7-WXUgJq",
  "wide0": "companies-frontend-b21b3468-wide0-WXUgJq",
  "confined11": "companies-frontend-b21b3468-confined11-WXUgJq",
  "tiny12": "companies-frontend-b21b3468-tiny12-WXUgJq",
  "xwideOffset8": "companies-frontend-b21b3468-xwideOffset8-WXUgJq",
  "tinyOffset8": "companies-frontend-b21b3468-tinyOffset8-WXUgJq",
  "armstrongGridContainer": "companies-frontend-b21b3468-armstrongGridContainer-WXUgJq",
  "default2": "companies-frontend-b21b3468-default2-WXUgJq",
  "confined7": "companies-frontend-b21b3468-confined7-WXUgJq",
  "confined4": "companies-frontend-b21b3468-confined4-WXUgJq",
  "wideOffset1": "companies-frontend-b21b3468-wideOffset1-WXUgJq",
  "xwideOffset1": "companies-frontend-b21b3468-xwideOffset1-WXUgJq",
  "confined3": "companies-frontend-b21b3468-confined3-WXUgJq",
  "xwide4": "companies-frontend-b21b3468-xwide4-WXUgJq",
  "xwideOffset11": "companies-frontend-b21b3468-xwideOffset11-WXUgJq",
  "gridContainer": "companies-frontend-b21b3468-gridContainer-WXUgJq",
  "xwide9": "companies-frontend-b21b3468-xwide9-WXUgJq",
  "default10": "companies-frontend-b21b3468-default10-WXUgJq",
  "default12": "companies-frontend-b21b3468-default12-WXUgJq",
  "default3": "companies-frontend-b21b3468-default3-WXUgJq",
  "wideOffset8": "companies-frontend-b21b3468-wideOffset8-WXUgJq",
  "xwide1": "companies-frontend-b21b3468-xwide1-WXUgJq",
  "xwideOffset5": "companies-frontend-b21b3468-xwideOffset5-WXUgJq",
  "wideOffset5": "companies-frontend-b21b3468-wideOffset5-WXUgJq",
  "standardGridContainer": "companies-frontend-b21b3468-standardGridContainer-WXUgJq",
  "xwideOffset9": "companies-frontend-b21b3468-xwideOffset9-WXUgJq",
  "confinedOffset10": "companies-frontend-b21b3468-confinedOffset10-WXUgJq",
  "tinyOffset0": "companies-frontend-b21b3468-tinyOffset0-WXUgJq",
  "wideGridContainer": "companies-frontend-b21b3468-wideGridContainer-WXUgJq",
  "defaultOffset5": "companies-frontend-b21b3468-defaultOffset5-WXUgJq",
  "xwideOffset4": "companies-frontend-b21b3468-xwideOffset4-WXUgJq",
  "xwide11": "companies-frontend-b21b3468-xwide11-WXUgJq",
  "tiny7": "companies-frontend-b21b3468-tiny7-WXUgJq",
  "defaultOffset9": "companies-frontend-b21b3468-defaultOffset9-WXUgJq",
  "xwide2": "companies-frontend-b21b3468-xwide2-WXUgJq",
  "confinedOffset0": "companies-frontend-b21b3468-confinedOffset0-WXUgJq",
  "confinedOffset4": "companies-frontend-b21b3468-confinedOffset4-WXUgJq",
  "wide4": "companies-frontend-b21b3468-wide4-WXUgJq",
  "row": "companies-frontend-b21b3468-row-WXUgJq",
  "wide12": "companies-frontend-b21b3468-wide12-WXUgJq",
  "tinyOffset9": "companies-frontend-b21b3468-tinyOffset9-WXUgJq",
  "defaultOffset1": "companies-frontend-b21b3468-defaultOffset1-WXUgJq",
  "tiny5": "companies-frontend-b21b3468-tiny5-WXUgJq",
  "xwideOffset6": "companies-frontend-b21b3468-xwideOffset6-WXUgJq",
  "xwideOffset10": "companies-frontend-b21b3468-xwideOffset10-WXUgJq",
  "xwideOffset7": "companies-frontend-b21b3468-xwideOffset7-WXUgJq",
  "wide1": "companies-frontend-b21b3468-wide1-WXUgJq",
  "col": "companies-frontend-b21b3468-col-WXUgJq",
  "wide2": "companies-frontend-b21b3468-wide2-WXUgJq",
  "xwide7": "companies-frontend-b21b3468-xwide7-WXUgJq",
  "confined6": "companies-frontend-b21b3468-confined6-WXUgJq",
  "confined5": "companies-frontend-b21b3468-confined5-WXUgJq",
  "wideOffset3": "companies-frontend-b21b3468-wideOffset3-WXUgJq",
  "defaultOffset11": "companies-frontend-b21b3468-defaultOffset11-WXUgJq",
  "confined10": "companies-frontend-b21b3468-confined10-WXUgJq",
  "defaultOffset3": "companies-frontend-b21b3468-defaultOffset3-WXUgJq",
  "confined2": "companies-frontend-b21b3468-confined2-WXUgJq",
  "wide8": "companies-frontend-b21b3468-wide8-WXUgJq",
  "confinedOffset7": "companies-frontend-b21b3468-confinedOffset7-WXUgJq",
  "tiny8": "companies-frontend-b21b3468-tiny8-WXUgJq",
  "confined8": "companies-frontend-b21b3468-confined8-WXUgJq",
  "confinedOffset9": "companies-frontend-b21b3468-confinedOffset9-WXUgJq",
  "default9": "companies-frontend-b21b3468-default9-WXUgJq",
  "wide6": "companies-frontend-b21b3468-wide6-WXUgJq",
  "tinyOffset4": "companies-frontend-b21b3468-tinyOffset4-WXUgJq",
  "wideOffset6": "companies-frontend-b21b3468-wideOffset6-WXUgJq",
  "confined0": "companies-frontend-b21b3468-confined0-WXUgJq",
  "wideOffset2": "companies-frontend-b21b3468-wideOffset2-WXUgJq",
  "wideOffset4": "companies-frontend-b21b3468-wideOffset4-WXUgJq"
};